// Tap choices for the intake form's listing fields. Anything not listed is typed under "Other".
import type { Kind } from '../../supabase/functions/_shared/listing-description.ts'

export const COLORS = ['Black', 'White', 'Grey', 'Cream', 'Blue', 'Red', 'Green', 'Brown', 'Pink', 'Purple', 'Yellow', 'Orange', 'Silver', 'Gold', 'Multi']
export const ERAS = ['1970s', '1980s', '1990s', '2000s', '2010s', '2020s']
export const GRAPHICS = ['Front', 'Back', 'Front and back', 'Sleeve', 'Embroidered', 'All-over print', 'Faded', 'Cracked', 'None']

/** Materials worth one tap, by kind of piece. */
export function materialsFor(k: Kind): string[] {
  switch (k) {
    case 'jewelry': return ['Sterling silver', '925 silver', 'Gold', 'Brass', 'Leather', 'Stainless steel']
    case 'shoes': return ['Leather', 'Suede', 'Canvas', 'Rubber', 'Nylon']
    case 'bag': return ['Leather', 'Canvas', 'Nylon', 'Suede', 'Denim']
    case 'eyewear': return ['Acetate', 'Metal', 'Titanium']
    case 'belt': return ['Leather', 'Silver', 'Canvas']
    case 'bottom': return ['Denim', 'Cotton', 'Leather', 'Nylon', 'Wool', 'Corduroy']
    case 'outer': return ['Leather', 'Denim', 'Cotton', 'Nylon', 'Wool', 'Suede', 'Fleece']
    default: return ['Cotton', 'Polyester', 'Cotton blend', 'Wool', 'Cashmere', 'Leather', 'Denim', 'Linen', 'Silk']
  }
}
